import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminTrainingsNew from './AdminTrainingsNew';

export default withRequiredAdmin(AdminTrainingsNew);
